<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <!-------------------------------------------STRING-------------------------------------------->
    <v-card
      v-if="dialog && imgObject.type === 'string'"
      flat
      color="grey-lighten-4"
      class="d-flex flex-column"
    >
      <!-- Toolbar -->
      <v-row align="center" class="pa-2 pt-4">
        <v-btn icon variant="text" @click="rotateL">
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn icon variant="text" @click="rotateR">
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn class="ma-2" variant="outlined" icon color="red" @click="close">
          <v-icon large> mdi-close </v-icon>
        </v-btn>
      </v-row>

      <!-- Carousel -->
      <v-row>
        <v-col cols="12">
          <v-carousel v-model="currentImageIndex" :cycle="false" height="auto">
            <v-carousel-item
              v-for="(image, index) in imgObject.images"
              :key="index"
            >
              <v-row align="center" justify="center" class="fill-height">
                <v-img
                  ref="image"
                  :style="{ transform: `rotate(${rotation}deg)` }"
                  :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${image.image}`"
                  aspect-ratio="1"
                  contain
                  style="width: 100%; height: auto"
                  @mousemove="zoomIn"
                  @mouseleave="zoomOut"
                >
                  <template #placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey-lighten-5"
                      />
                    </v-row>
                  </template>
                </v-img>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-card>

    <!-------------------------------------------DATAURL------------------------------------------->
    <v-card
      v-else-if="dialog && imgObject.type === 'dataUrl'"
      flat
      color="grey-darken-4"
      class="d-flex flex-column"
    >
      <!-- Toolbar -->
      <v-row align="center" class="pa-2">
        <v-btn dark icon @click="rotateL">
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn dark icon @click="rotateR">
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn class="ma-2" variant="outlined" icon color="red" @click="close">
          <v-icon large> mdi-close </v-icon>
        </v-btn>
      </v-row>

      <!-- Carousel -->
      <v-row>
        <v-col cols="12">
          <v-carousel :cycle="false" height="auto">
            <v-carousel-item
              v-for="(image, index) in imgObject.images"
              :key="index"
            >
              <v-row align="center" justify="center" class="fill-height">
                <v-img
                  :style="{ transform: `rotate(${rotation}deg)` }"
                  :src="image"
                  aspect-ratio="1"
                  contain
                >
                  <template #placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey-lighten-5"
                      />
                    </v-row>
                  </template>
                </v-img>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import zoom from "../utils/zoom";

export default {
  data: () => ({
    dialog: false,
    rotation: 0,
    images: [],
    currentImageIndex: 0,
    imgObject: {
      type: null,
      id: null,
      date: null,
      images: [],
    },
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.close();
      }
    },
  },
  methods: {
    open(data) {
      this.imgObject = data;
      this.dialog = true;
    },
    close() {
      this.imgObject = {
        type: null,
        id: null,
        date: null,
        images: [],
      };
      this.rotation = 0;
      this.dialog = false;
      this.currentImageIndex = 0;
    },
    rotateR() {
      this.rotation += 90;
      const imgSrc = this.$refs.image[this.currentImageIndex].src;
      axios.put(imgSrc, { rotate: this.rotation });
    },
    rotateL() {
      this.rotation -= 90;
      const imgSrc = this.$refs.image[this.currentImageIndex].src;
      axios.put(imgSrc, { rotate: this.rotation });
    },
    zoomIn(event) {
      zoom.zoomIn(2.4, event, this.rotation);
    },
    zoomOut(event) {
      zoom.zoomOut(event, this.rotation);
    },
  },
};
</script>
